import staticPageHeader from '@/components/static-page-header/static-page-header.vue';
import seoMetaMixin from '@/mixins/seoMeta';

export default {
  mixins: [
    seoMetaMixin,
  ],
  components: {
    staticPageHeader,
  },
  metaInfo() {
    return this.buildSeoMeta({
      title: 'Page Not Found',
      extraMeta: [
        { name: 'prerender-status-code', content: '404' },
        { name: 'robots', content: 'noindex,nofollow' },
      ],
    });
  },
};



// WEBPACK FOOTER //
// ./src/components/pages/page-not-found/page-not-found.js